import React from "react";
import FullLoader from "../loaders/FullLoader";
import FarmyModalsBlock from "./modals/FarmyModalsBlock";
import MobileBottomDrawer from "./bottomDrawer/MobileBottomDrawer";
import useCookieConsentBanner from "./useCookieConsentBanner";

import useWindowTools from "../../react-hooks/useWindowTools";

const TopLayer = () => {
  useCookieConsentBanner();
  const {isMobile} = useWindowTools();

  return <>
    <FullLoader/>
    <FarmyModalsBlock/>

    {isMobile && <MobileBottomDrawer/>}
  </>;
};

export default TopLayer;
